import React, { useEffect, useRef, useState } from "react";
import {
  InputField,
  Modal,
  SearchInput,
  Steps,
  SubmitButton,
  TextComponent,
  TimeInput,
} from "../../../../components";
import styles from "./groupAssets.module.css";
import { Checkbox, List, Popover } from "antd";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { LuCircleDot } from "react-icons/lu";
import assetsAssignImg from "../../../../assets/images/car.png";
import { FiClock } from "react-icons/fi";
import { IoMdAddCircle } from "react-icons/io";
import Switch from "../../../../components/Switch/Switch";
import { IoCloseCircleSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import moment from "moment";
import DateInput from "../../../../components/DateInput/DateInput";

const AddGroupAssetModal = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [step, setStep] = useState(1);
  const [status, setStatus] = useState("Immobilized");
  const [search, setSearch] = useState("");
  const [assetArray, setAssetArray] = useState([]);
  const [frequency, setFrequency] = useState("one_time");
  const [title, setTitle] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const SingleAssets = useSelector(
    (state) => state.AssetsReducer.getSingleAssets,
  );

  const ref = useRef();
  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(AssetsMiddleware.getSingleAssets(value)).then((data) => {});
    }, 1000);
  };

  const getData = (name) => {
    dispatch(AssetsMiddleware.getSingleAssets(name)).then((data) => {});
  };
  useEffect(() => {
    getData();
  }, []);

  let times = [
    {
      id: 1,
      time: "10:00 AM",
      status: "Drive",
      type: "Daily",
    },
  ];

  const onChange = (item) => {
    let dummyArr = [...assetArray];
    const findItem = dummyArr.find((e) => e?.id == item?.id);
    if (findItem) {
      const dltItem = assetArray.filter((e) => e?.id != findItem?.id);
      setAssetArray(dltItem);
    } else {
      dummyArr.push(item);
      setAssetArray(dummyArr);
    }
  };

  const onCreateGroup = () => {
    let userData = {
      title,
      assetArray,
      // startTime: moment(startTime).format("HH:mm"),
      // endTime: moment(endTime).format("HH:mm"),
      // startDate: moment(startDate).format("YYYY-MM-DD"),
      // endDate: moment(endDate).format("YYYY-MM-DD"),
      // frequency,
    };
    if (
      !title ||
      assetArray?.length == 0
      // !startTime ||
      // !endTime ||
      // !frequency ||
      // !startDate ||
      // !endDate
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        }),
      );
    } else {
      dispatch(AssetsMiddleware.creatAssetGroup(userData))
        .then(() => {
          setStep(1);
          setSuccess(true);
          setIsOpen(false);
          setAssetArray([]);
          // setFrequency("one_time");
          // setStartTime(null);
          // setEndTime(null);
          // setTitle("");
          // setStartDate(null);
          // setEndDate(null);
        })
        .catch(() => {});
    }
  };
  const renderAssets = (item) => {
    const findItem = assetArray.find((e) => e?.id == item?.id);
    return (
      <div className={styles.moduleCont}>
        <div className={styles.moduleSubCont}>
          <img
            className={styles.moduleImg}
            src={item?.image ? item?.image : imagePlaceholder}
            alt="Device image"
          />
          <TextComponent
            text={item?.device_id ? item?.device_id : "-"}
            className={styles.heading}
          />
        </div>

        <Checkbox checked={findItem} onChange={() => onChange(item)} />
      </div>
    );
  };

  const onPressNext = () => {
    if (step == 1 && (!title || assetArray?.length == 0)) {
      // setStep(2);
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        }),
      );
    } else {
      setStep(2);
      // setSuccess(true);
      // setIsOpen(false);
    }
  };

  const onPressBack = () => {
    if (step == 2) {
      setStep(1);
    } else {
      setIsOpen(false);
    }
  };

  const renderTime = (item) => {
    return (
      <div className={styles.timeCont}>
        <TextComponent text={item?.type} className={styles.type} />
        <TextComponent text={item?.time} className={styles.time} />
        <TextComponent text={`"${item?.status}"`} className={styles.status} />
        <Switch
          // label="Enable Feature"
          size="small"
          disabled
          activeColor={"var(--green-color)"}
          inactiveColor={"var(--primary-color)"}
          initialChecked={item.status == "Drive" ? true : false}
          isChecked={item.status == "Drive" ? true : false}
          // onChange={handleSwitchChange} // Pass callback function
        />
        <IoCloseCircleSharp
          size={22}
          className={styles.crossIcon}
          style={{ alignSelf: "flex-end", marginLeft: "auto" }}
        />
      </div>
    );
  };

  const steps = ["Step 1", "Step 2"];

  return (
    <>
      {isOpen && (
        <Modal
          open={isOpen}
          onCancel={() => {
            setStep(1);
            setIsOpen(false);
          }}
          width={"800px"}
          btnDiv={styles.access_modalBtn}
          btnStyle={{ width: "80%" }}
        >
          <div className={styles.mainCont}>
            <Steps steps={steps} currentStep={step} />
            <img src={assetsAssignImg} className={styles.carImg} />
            <TextComponent
              id={"title"}
              text={
                step == 1 ? "Create Vehicle group" : "Schedule Vehicle group"
              }
              className={styles.heading2}
            />
            {step == 1 ? (
              <>
                <InputField
                  label={"Group name"}
                  className={styles.formDivideInput}
                  placeholder={"Write here"}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <SearchInput value={search} onChange={(e) => onSearch(e)} />
                <List
                  dataSource={SingleAssets?.data}
                  renderItem={renderAssets}
                  style={{ width: "100%" }}
                />
                <SubmitButton
                  title={"Save"}
                  style={{ marginTop: "10px" }}
                  onClick={onCreateGroup}
                />
                {/* <SubmitButton
                  title={"Next"}
                  style={{ marginTop: "10px" }}
                  onClick={onPressNext}
                /> */}
                <SubmitButton
                  title={"Go Back"}
                  style={{ marginTop: "10px" }}
                  secondaryBtn
                  onClick={onPressBack}
                />
                {/* <TextComponent text={"+4 more"} className={styles.more} /> */}
              </>
            ) : (
              <div className={styles.schedule_modalMain}>
                {/* <List dataSource={times} renderItem={renderTime} /> */}
                <div className={styles.schedule_inputBox}>
                  <div className={styles.schedule_input}>
                    <DateInput
                      label={"Start Date"}
                      // value={startTime}
                      value={startDate ? moment(startDate) : null}
                      onChange={(e) => setStartDate(e?.$d)}
                      icon={<FiClock color="var(--secondary-color)" />}
                    />
                  </div>
                  <div className={styles.schedule_input}>
                    <DateInput
                      label={"End Date"}
                      value={endDate ? moment(endDate) : null}
                      onChange={(e) => setEndDate(e?.$d)}
                      icon={<FiClock color="var(--secondary-color)" />}
                    />
                  </div>
                </div>
                <div className={styles.schedule_inputBox}>
                  <div className={styles.schedule_input}>
                    <TimeInput
                      label={"Start time"}
                      value={startTime ? moment(startTime) : null}
                      onChange={(e) => setStartTime(e?.$d)}
                      icon={<FiClock color="var(--secondary-color)" />}
                    />
                  </div>
                  <div className={styles.schedule_input}>
                    <TimeInput
                      label={"End time"}
                      value={endTime ? moment(endTime) : null}
                      onChange={(e) => setEndTime(e?.$d)}
                      icon={<FiClock color="var(--secondary-color)" />}
                    />
                  </div>
                </div>
                {/* <div className={styles.schedule_btn_div}>
                  <SubmitButton
                    // secondaryBtn
                    title={"Add more"}
                    // onClick={onBtnPress}
                    textClass={styles.addBtnText}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alingItem: "center",
                    }}
                    leftIcon={
                      <IoMdAddCircle size={15} color="var(--white-color)" />
                    }
                    btnClass={`${styles.addBtn}`}
                  />
                </div> */}
                <TextComponent
                  text={"Status"}
                  style={{
                    fontFamily: "Urbanist-semibold",
                    fontSize: "var(--mobile-heading)",
                  }}
                />
                {/* <div className={styles.schedule_inputBox}>
                  <TextComponent
                    text={"Immobilized"}
                    className={
                      status == "Immobilized"
                        ? styles.schedule_frequencyBtn
                        : styles.schedule_frequencyUnactiveBtn
                    }
                    onClick={() => setStatus("Immobilized")}
                  />
                  </div>
                  <TextComponent
                    text={"Drive"}
                    className={
                      status == "Drive"
                        ? styles.schedule_frequencyBtn
                        : styles.schedule_frequencyUnactiveBtn
                    }
                    onClick={() => setStatus("Drive")}
                  />
                </div> */}
                {/* <TextComponent
                  text={"Set frequency"}
                  style={{
                    fontFamily: "Urbanist-semibold",
                    fontSize: "var(--mobile-heading)",
                  }}
                />
                <div className={styles.schedule_inputBox}>
                  <TextComponent
                    text={"One time"}
                    className={
                      frequency == "one_time"
                        ? styles.schedule_frequencyBtn
                        : styles.schedule_frequencyUnactiveBtn
                    }
                    onClick={() => setFrequency("one_time")}
                  />
                  <TextComponent
                    text={"Until I turn it off "}
                    className={
                      frequency == "one_time"
                        ? styles.schedule_frequencyUnactiveBtn
                        : styles.schedule_frequencyBtn
                    }
                    onClick={() => setFrequency("until_turn_off")}
                  />
                </div> */}
                <SubmitButton
                  title={"Save"}
                  style={{ marginTop: "10px" }}
                  onClick={onCreateGroup}
                />
                <SubmitButton
                  title={"Go Back"}
                  style={{ marginTop: "10px" }}
                  secondaryBtn
                  onClick={onPressBack}
                />
              </div>
            )}
          </div>
        </Modal>
      )}
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Group Added Successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </>
  );
};

export default AddGroupAssetModal;
